var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tabBar',{attrs:{"activeIndex":0,"mouseenterIndex":20}}),_c('div',{})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }